// Image compression utility
// Compresses images to target size (default 200KB)

export const compressImage = (file, maxSizeKB = 200) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // Calculate new dimensions while maintaining aspect ratio
        const maxDimension = 1920;
        if (width > maxDimension || height > maxDimension) {
          if (width > height) {
            height = (height / width) * maxDimension;
            width = maxDimension;
          } else {
            width = (width / height) * maxDimension;
            height = maxDimension;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // Start with high quality and reduce until under target size
        let quality = 0.9;
        let result = canvas.toDataURL('image/jpeg', quality);
        
        // Iteratively reduce quality until file is under target size
        const targetSize = maxSizeKB * 1024; // Convert KB to bytes
        while (result.length > targetSize && quality > 0.1) {
          quality -= 0.1;
          result = canvas.toDataURL('image/jpeg', quality);
        }
        
        // If still too large, reduce dimensions
        if (result.length > targetSize) {
          const scale = Math.sqrt(targetSize / result.length);
          canvas.width = width * scale;
          canvas.height = height * scale;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          result = canvas.toDataURL('image/jpeg', 0.7);
        }
        
        resolve(result);
      };
      
      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };
    };
    
    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };
  });
};

// Compress multiple files
export const compressImages = async (files, maxSizeKB = 200) => {
  const compressed = [];
  for (const file of files) {
    try {
      const result = await compressImage(file, maxSizeKB);
      compressed.push(result);
    } catch (error) {
      console.error('Failed to compress image:', error);
    }
  }
  return compressed;
};
